import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
  selector: 'app-esvr-date-time-information',
  templateUrl: './esvr-date-time-information.component.html',
  styleUrls: ['./esvr-date-time-information.component.scss'],
})
export class EsvrDateTimeInformationComponent implements OnInit {
  @Input() editing: boolean;
  constructor(public formRef: ControlContainer) {}

  ngOnInit() {}

  get formGroup() {
    return this.formRef ? this.formRef.control : null;
  }

  getFieldValue(field: string) {
    const fieldValue = this.formGroup?.get(field).value;
    return fieldValue;
  }
}
